import profile from '@/api/empoyee/profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  positionList: [],
  departmentList: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_POSITION(state, data){
    state.positionList = data
  },
  SET_DEPARTMENT(state, data){
    state.departmentList = data
  },
  CLEAR_SETUP(state){
    state.positionList = []
    state.departmentList = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return profile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return profile.store(data)
  },
  update(context, { id, data }) {
    return profile.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await profile.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id){
    return profile.destroy(id)
  },
  async position(context){
    let response = await profile.position()
    context.commit('SET_POSITION', response.data)
  },
  async department(context){
    let response = await profile.department()
    context.commit('SET_DEPARTMENT', response.data)
  },
  upload(context, { id, data}){
    return profile.upload(id, data)
  }
}